module.exports = __webpack_public_path__ + "img/md5v7.a108fa2c.png";